import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import lefticon from "../images/Leftnew.svg";

export default function ForgetPage() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(
        "https://app.metabolytics.ai/simulator-backend/healthcare/forgot-password",
        { email }
      );
      alert("Password reset link sent! Check your email.");
      // Navigate to the verification page or login page after successful submission
      navigate("/login");
    } catch (error) {
      alert(
        error.response?.data?.message ||
          "Failed to send reset link. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="Login-container-bg">
      <div className="Login-container-main">
        <div className="setup-container-main">
          <div className="setup-icon-container" onClick={() => navigate(-1)}>
            <img src={lefticon} alt="Left Icon" className="setup-icon" />
          </div>
          <h2 className="setup-title">Forgot Your Password?</h2>
          <p className="setup-description">
            Type your email address and we will send the verification code.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="email-input-container">
              <label className="email-label">EMAIL</label>
              <input
                type="email"
                className="email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                disabled={isSubmitting}
              />
            </div>
            <div className="login-button-container">
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : "Reset Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
